import * as React from 'react'
import styles from './style.module.scss'

type Cell = React.ReactNode | string
type Row = Cell[]
type ColValue = Cell[]

type Align = 'left' | 'center' | 'right'

type Props = {
  title?: string
  header?: ColValue // one header row
  body?: Row[] // many rows
  footer?: ColValue // one footer row

  /** Optional: column alignments by index */
  align?: Align[]

  /** Optional: make header sticky (requires parent height/overflow) */
  stickyHeader?: boolean

  /** Optional: show borders between columns */
  withColDividers?: boolean

  /** Optional: compact mode */
  dense?: boolean

  /** Tailwind class overrides (prefixed with tw-) */
  className?: string
  tableClassName?: string

  children?: React.ReactNode
}

const alignToClass: Record<Align, string> = {
  left: 'tw-text-left',
  center: 'tw-text-center',
  right: 'tw-text-right',
}

function cn(...parts: Array<string | false | null | undefined>) {
  return parts.filter(Boolean).join(' ')
}

export const AmountsTable: React.FC<Props> = ({
  header,
  body,
  footer,
  align,
  stickyHeader = false,
  withColDividers = false,
  dense = false,
  className,
  tableClassName,
  children,
  title,
}) => {
  return (
    <div className={cn(styles.wrapper, className)}>
      {title && (<h3 className='tw-font-semibold tw-text-base tw-mb-2'>{title}</h3>)}
      
      <table className={cn(styles.table, tableClassName)}>{children}</table>
    </div>
  )
}

